import { MOSCOW_AND_MOSCOW_AREA_ID, PETERSBURG_AND_REGION_ID } from '@/packages/Filters/shared/constants/regions';
import { type ILocation, type TCurrentLocation } from '@/packages/Filters/shared/types/location';

export const getRegionId = (location: TCurrentLocation): number =>
  (location === 'moscow_mo' && MOSCOW_AND_MOSCOW_AREA_ID) ||
  (location === 'spb_lo' && PETERSBURG_AND_REGION_ID) ||
  (location as ILocation).parentId ||
  (location as ILocation).id;
